var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-message at-deletemsg"},[(!_vm.messageProps.isSender && _vm.messageProps.chatType == 2 )?_c('h5',[_vm._v(_vm._s(_vm.messageProps.userName))]):_vm._e(),_c('div',{staticClass:"at-del-msg"},[_c('i',{staticClass:"guppy-slash"}),_vm._v(" "+_vm._s(_vm.TRANS.deleted_message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }